import { apiAxios as authAxios } from '../axios.config';

export const listProfiles = () => {
    return authAxios.get('/api/profile');
}